webpackJsonp([0],{

/***/ "/1vZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6nIi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Background__ = __webpack_require__("SAI9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',

  components: {
    Background: __WEBPACK_IMPORTED_MODULE_0__Background__["a" /* default */]
  }
});

/***/ }),

/***/ "HCTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Header'
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__state__ = __webpack_require__("lwq5");







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_5__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  strict: false
}));

/***/ }),

/***/ "KGHi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("© Web3Data Foundation "+_vm._s(_vm.year))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ksms":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('section',{staticClass:"intro"},[_c('Background'),_vm._v(" "),_vm._m(0)],1),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/web3data.org.svg","alt":""}}),_vm._v(" "),_c('h1',{staticClass:"pg-title"},[_vm._v("web3data.org")]),_vm._v(" "),_c('h3',[_vm._v("The Blockchain Data Nexus")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"features"},[_c('div',{staticClass:"grid"},[_c('div',{staticClass:"grid-column grid-cl-1"},[_c('div',{staticClass:"card-portrait"},[_c('div',{staticClass:"bg-img bg-1"}),_vm._v(" "),_c('div',{staticClass:"bg-img ol-1"}),_vm._v(" "),_c('h1',[_vm._v("Economic Driven Data")]),_vm._v(" "),_c('p',[_vm._v("Participants may earn tokens for collecting, forwarding and validating public blockchain data to Amberdata’s or other service providers’ ingestion APIs")])])]),_vm._v(" "),_c('div',{staticClass:"grid-column grid-cl-2"},[_c('div',{staticClass:"card-portrait"},[_c('div',{staticClass:"bg-img bg-2"}),_vm._v(" "),_c('div',{staticClass:"bg-img ol-1"}),_vm._v(" "),_c('h1',[_vm._v("Network Sourced Data")]),_vm._v(" "),_c('p',[_vm._v("Community data listed in the marketplace and made available via API or bulk download is expected to be monetized by the data provider receiving payments in tokens.")])]),_vm._v(" "),_c('div',{staticClass:"card-portrait"},[_c('div',{staticClass:"bg-img bg-3"}),_vm._v(" "),_c('div',{staticClass:"bg-img ol-1"}),_vm._v(" "),_c('h1',[_vm._v("Curated Data Sets")]),_vm._v(" "),_c('p',[_vm._v("Low friction peer-to-peer mechanisms to publish, consume and monetize blockchain, custom and curated datasets")])])]),_vm._v(" "),_c('div',{staticClass:"grid-column grid-cl-3"},[_c('div',{staticClass:"card-portrait"},[_c('div',{staticClass:"bg-img bg-4"}),_vm._v(" "),_c('div',{staticClass:"bg-img ol-1"}),_vm._v(" "),_c('h1',[_vm._v("Decentralized Validated Information")]),_vm._v(" "),_c('p',[_vm._v("A blockchain data marketplace is global value proposition and flattens the world enabling peer-to-peer commerce on a global scale.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d80182a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("x75/");
function injectStyle (ssrContext) {
  __webpack_require__("6nIi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d80182a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "SAI9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Background_vue__ = __webpack_require__("vdG/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bf9deaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Background_vue__ = __webpack_require__("cGhe");
function injectStyle (ssrContext) {
  __webpack_require__("dd8D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bf9deaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Background_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bf9deaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Background_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TVmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("UthT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_745ee3df_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("KGHi");
function injectStyle (ssrContext) {
  __webpack_require__("fNC6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-745ee3df"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_745ee3df_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  connected: function connected(state) {
    return state.connected;
  }
});

/***/ }),

/***/ "UthT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Footer',

  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, { path: '/*', redirect: '/' }]
}));

/***/ }),

/***/ "cGhe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"anim"},[_c('svg',{attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"1280px","height":"800px","viewBox":"0 0 1280 800","enable-background":"new 0 0 1280 800","xml:space":"preserve"}},[_c('path',{attrs:{"id":"Shape","fill":"none","stroke-dashoffset":"100%","stroke":"#31B495","d":"M376.98,463.77v69.78c0,1.08,0.88,1.96,1.97,1.96l135.12-0.04c1.09,0,2.6,0.62,3.38,1.391l39.229,38.96c0.933,0.835,2.121,1.328,3.37,1.399h75.38c1.088,0,1.971-0.882,1.971-1.97v-33.5"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_83_","fill":"none","stroke-dashoffset":"100%","stroke":"#1AACA8","d":"M582.53,481v21.64c0,1.07,0.89,1.96,1.97,1.96l85.81-0.04c1.091,0,2.601,0.62,3.381,1.391l1.55,1.54c0.935,0.837,2.127,1.331,3.38,1.399h9.29"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_82_","fill":"none","stroke-dashoffset":"100%","stroke":"#1AACA8","d":"M651-101.68v265.47c-0.006,2.205-1.795,3.99-4,3.99h-55c-1.08,0-1.97,0.88-1.97,1.96v147.5c0,1.08,0.63,2.59,1.399,3.35l3.445,3.409"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_2_","fill":"none","stroke-dashoffset":"100%","stroke":"#1F8C43","d":"M1150,102.82v391.06c0,2.216-1.784,4.019-4,4.04L1017.2,499"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_3_","fill":"none","stroke-dashoffset":"100%","stroke":"#1AA5D0","d":"M263.99,349l-49.8-49.44c-0.932-0.835-2.121-1.328-3.37-1.399h-92.41c-1.09,0-2.6,0.63-3.38,1.399l-27.18,26.99"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_4_","fill":"none","stroke-dashoffset":"100%","stroke":"#1AA5D0","d":"M263.99,349l-49.8-49.44c-0.932-0.835-2.121-1.328-3.37-1.399h-92.41c-1.09,0-2.6,0.63-3.38,1.399l-27.18,26.99"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_5_","fill":"none","stroke-dashoffset":"100%","stroke":"#DA5A98","d":"M593.2,524.64V542.4c0,1.08,0.64,2.59,1.399,3.35L775.72,725.6c0.937,0.834,2.128,1.324,3.38,1.391H888.2c1.09,0,1.97,0.88,1.97,1.96v23.37c0,1.069,0.9,1.96,1.98,1.96h83.539c1.08,0,1.971,0.88,1.971,1.96v45.8c0,1.07-0.891,1.95-1.971,1.95H945.8c-1.08,0-1.97,0.88-1.97,1.96v51.069c0,1.08-0.63,2.591-1.4,3.351l-10.319,10.25c-0.771,0.76-2.29,1.39-3.37,1.39H816.97c-1.09,0-1.34,0.62-0.569,1.391 M675.18,631H105"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_6_","fill":"none","stroke-dashoffset":"100%","stroke":"#E5683E","d":"M717.47,220.87l31.7,31.48c0.934,0.832,2.122,1.322,3.37,1.39h62.37c1.09,0,2.6,0.62,3.38,1.39l2.68,3.66l264.591,0.02c1.079,0,2.6-0.63,3.369-1.4l47.301-46.97c0.934-0.832,2.121-1.322,3.369-1.39h57.471l1.119-34.61c0-1.08,0.631-2.59,1.4-3.35l66.54-65.94"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_52_","fill":"none","stroke-dashoffset":"100%","stroke":"#9F83B6","d":"M804.517,480.996L937.29,614.06c0.925,0.835,2.106,1.329,3.35,1.4h186.3"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_80_","fill":"none","stroke-dashoffset":"100%","stroke":"#9F83B6","d":"M452.69,196.73h-7.83c-1.09,0-2.6,0.63-3.37,1.4l-45.8,45.6c-0.78,0.76-1.4,2.27-1.4,3.35v13.94c0,1.08-0.46,1.96-1.03,1.98c-0.56,0-1.03,0.9-1.03,1.98v10.77l0.15,110.84c0,1.08,0.89,1.96,1.98,1.96H452"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_53_","fill":"none","stroke-dashoffset":"100%","stroke":"#BC6D21","d":"M791.348,481l106.416,105.78c0.966,1.067,1.537,2.435,1.618,3.872L899.197,796.2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_79_","fill":"none","stroke-dashoffset":"100%","stroke":"#BC6D21","d":"M1064.121-38L897.498,128.53c-0.89,0.878-2.646,1.606-3.895,1.606H723.987c-1.26,0-3.005,0.717-3.906,1.606l-36.903,36.648c-0.89,0.89-1.618,2.624-1.618,3.872V324"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_35_","fill":"none","stroke-dashoffset":"100%","stroke":"#DA1817","d":"M547.25,324v-5.47c0-1.07,0.63-2.58,1.4-3.34L561,302.92c0.934-0.831,2.122-1.321,3.37-1.39h17.399c1.091,0,2.601-0.62,3.381-1.391l41.8-41.5c0.932-0.835,2.12-1.329,3.37-1.4h41.34"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_10_","fill":"none","stroke-dashoffset":"100%","stroke":"#74BB63","d":"M420,169.4H242.96c-1.09,0-1.97,0.89-1.97,1.96v28.74c0,1.08-0.64,2.59-1.4,3.35l-50.96,50.6c-0.77,0.76-1.4,2.27-1.4,3.35v101.47L82.03,463.14"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_11_","fill":"none","stroke-dashoffset":"100%","stroke":"#DA5A98","d":"M519.54,280.73L507,268.29c-0.77-0.74-0.77-2,0-2.76l31.35-31.13c0.761-0.74,0.761-2,0-2.76l-18.529-18.4c-0.934-0.832-2.122-1.322-3.37-1.39l-160.41-0.2l-423.37,1.2c-1.08,0-1.97,0.89-1.97,1.96v71.5"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_9_","fill":"none","stroke-dashoffset":"100%","stroke":"#BC6D21","d":"M835,383.82h23.18c1.08,0,2.601-0.62,3.37-1.38l47-46.681l36.58-0.04l57,71.59c0.836,0.924,1.33,2.106,1.4,3.351v163.984"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_13_","fill":"none","stroke-dashoffset":"100%","stroke":"#74BB63","d":"M835,395.43h346.82l88.649,0.2l12.44,12.351"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_57_","fill":"none","stroke-dashoffset":"100%","stroke":"#74BB63","d":"M275.94,333.97l46.92,46.601c0.936,0.833,2.128,1.323,3.38,1.39h94.64c1.09,0,2.6-0.63,3.38-1.4L452,353.065"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_32_","fill":"none","stroke-dashoffset":"100%","stroke":"#2283BC","d":"M577.23,324v-25.58c0-1.08,0.64-2.59,1.399-3.35l110.46-109.68c0.935-0.837,2.127-1.331,3.38-1.4l180.49,0.2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_74_","fill":"none","stroke-dashoffset":"100%","stroke":"#2283BC","d":"M865.1,618.74l-59.56-59.12c-0.934-0.832-2.122-1.321-3.37-1.39h-23.93c-1.08,0-2.601-0.631-3.37-1.391l-46.53-46.21c-0.935-0.837-2.127-1.331-3.38-1.399h-33.53l-153.67-0.011c-1.08,0-1.97-0.88-1.97-1.96V481"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_15_","fill":"none","stroke-dashoffset":"100%","stroke":"#DA5A98","d":"M673.87,523.71h37.09c1.08,0,2.6,0.63,3.37,1.4l69.02,68.54c0.771,0.76,0.771,2,0,2.76l-28.09,27.78c-0.77,0.76-2.29,1.39-3.37,1.39H689.48"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_73_","fill":"none","stroke-dashoffset":"100%","stroke":"#31B495","d":"M700.5,324v-32.02c0-1.08-0.63-2.601-1.4-3.36l-20.89-20.74c-0.836-0.924-1.33-2.106-1.4-3.35v-95.4c0-1.08,0.631-2.58,1.4-3.35L865.6-20.3l0.601-40.88c0-1.08,0.62-2.58,1.399-3.35L879.2-76.07"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_72_","fill":"none","stroke-dashoffset":"100%","stroke":"#31B495","d":"M637.18,536.7v-4.74c0-1.08,0.891-1.96,1.98-1.96h13.21c1.09,0,2.6-0.62,3.37-1.39l43.359-42.88c0.836-0.924,1.33-2.106,1.4-3.351V481"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_30_","fill":"none","stroke-dashoffset":"100%","stroke":"#1EB2D8","d":"M498.92,324v-37.71c0-1.07,0.63-2.58,1.4-3.35l51.84-51.3c0.935-0.837,2.127-1.331,3.38-1.4h17.95c1.08,0,1.959-0.87,1.97-1.95v-44.47c0-1.07,0.89-1.96,1.97-1.96h88.63c1.085,0,1.965-0.876,1.971-1.96v-19.2c0-1.07,0.64-2.58,1.399-3.34l178.7-177.44"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_29_","fill":"none","stroke-dashoffset":"100%","stroke":"#1EB2D8","d":"M882.24,720h-99.28c-1.09,0-2.6-0.63-3.38-1.4L605.25,545.85c-0.935-0.837-2.127-1.331-3.38-1.399h-46.75c-1.08,0-2.601-0.62-3.351-1.38l-51.47-51.46c-0.83-0.926-1.317-2.108-1.38-3.351V481"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_18_","fill":"none","stroke-dashoffset":"100%","stroke":"#F4D21F","d":"M74.5,98.83h157c1.08,0,2.6,0.62,3.37,1.39l92.28,91.46c0.934,0.832,2.122,1.321,3.37,1.39l131.87-0.08c1.09,0,2.6,0.63,3.37,1.37l51.9,51.19c0.77,0.76,0.77,2,0,2.76l-21.22,21.1c-0.771,0.76-1.4,2.27-1.4,3.35v15.69"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_50_","fill":"none","stroke-dashoffset":"100%","stroke":"#BE2F39","d":"M452,412.64h-20.76c-1.08,0-2.6,0.63-3.37,1.4l-49.04,48.7c-0.77,0.76-2.29,1.38-3.37,1.38H330.3c-1.08,0-2.6-0.62-3.37-1.39L243.61,380c-0.932-0.835-2.121-1.329-3.37-1.4h-42.22c-1.08,0-2.6,0.631-3.37,1.4L22.975,550.975"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_48_","fill":"none","stroke-dashoffset":"100%","stroke":"#E5683E","d":"M452,409.31h-22.14c-1.08,0-2.6,0.631-3.37,1.4l-49.14,48.8c-0.77,0.76-2.29,1.38-3.37,1.38l-41.9-0.04c-1.08,0-2.6-0.619-3.37-1.39l-62.08-61.68c-0.836-0.924-1.33-2.106-1.4-3.351l0.1-268.18c0-1.08,0.63-2.59,1.4-3.35l99.8-99.28c0.933-0.832,2.122-1.322,3.37-1.39h365.48c1.08,0,2.601,0.63,3.37,1.4L897.72,181.3c0.937,0.834,2.128,1.324,3.38,1.39H1030.7c1.08,0,2.6,0.62,3.37,1.39l36.71,36.45c0.836,0.924,1.33,2.106,1.399,3.35V408.98"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_21_","fill":"none","stroke-dashoffset":"100%","stroke":"#1EB2D8","d":"M747.9,688.73l-17.53,17.42c-0.771,0.76-2.29,1.39-3.37,1.39h-42.02c-1.091,0-2.601-0.63-3.37-1.4l-26.021-25.83L309.5,680"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_46_","fill":"none","stroke-dashoffset":"100%","stroke":"#2283BC","d":"M452.002,376.351L413.94,338.56c-0.932-0.835-2.121-1.328-3.37-1.399h-6.11c-1.09,0-2.6-0.62-3.38-1.38l-53.12-52.761c-0.934-0.831-2.122-1.321-3.37-1.39h-13.6c-1.08,0-2.6,0.63-3.37,1.4L265.21,345c-0.77,0.77-2.29,1.4-3.37,1.4h-74.06c-1.08,0-2.6,0.619-3.37,1.38l-93.97,93.5"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_40_","fill":"none","stroke-dashoffset":"100%","stroke":"#2283BC","d":"M850.66,882.08c-0.771-0.771-0.521-1.4,0.57-1.4h198.479c1.084,0.006,1.969-0.865,1.979-1.949V718.59c0-1.08-0.899-1.96-1.979-1.96H785.33c-1.09,0-2.6-0.63-3.38-1.399l-23.75-23.58c-0.771-0.761-0.771-2,0-2.761l80.84-80.1c0.77-0.76,0.51-1.4-0.57-1.4H700.94c-1.091,0-2.601-0.62-3.381-1.38l-53.63-53.26c-0.932-0.835-2.12-1.329-3.37-1.4l-88.569-0.199c-1.09,0-2.601-0.62-3.38-1.381l-55.601-55.22c-0.836-0.924-1.33-2.106-1.399-3.35V481"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_7_","fill":"none","stroke-dashoffset":"100%","stroke":"#E6632A","d":"M835,336.07h313.7c1.08,0,2.6,0.63,3.37,1.399l37.899,37.62c0.933,0.835,2.121,1.329,3.37,1.4h57c1.1,0,2.61,0.62,3.38,1.38l13.2,13.1c0.933,0.836,2.12,1.329,3.37,1.4h13.2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_25_","fill":"none","stroke-dashoffset":"100%","stroke":"#F4D21F","d":"M452,330.95h-58.65c-1.09,0-2.6-0.62-3.37-1.38l-43.58-43.28c-0.934-0.832-2.122-1.321-3.37-1.39h-10.6c-1.08,0-2.6,0.63-3.37,1.399l-62.65,62.2c-0.77,0.77-2.29,1.4-3.37,1.4h-73.87c-1.09,0-2.6,0.63-3.38,1.399l-94.12,93.47l-9.27,0.57c-0.84,0-2.17-0.62-2.93-1.39l-104.08-89.36c-0.769-0.766-2.011-0.766-2.78,0l-6.3,6.25"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_49_","fill":"none","stroke-dashoffset":"100%","stroke":"#F4D21F","d":"M1247,332H835"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_68_","fill":"none","stroke-dashoffset":"100%","stroke":"#9DCA40","d":"M709.58,481v4.91c0,1.29-0.75,3.1-1.68,4.01l-47.931,47.6c-1.12,1.002-2.549,1.591-4.05,1.671h-97.84c-1.497-0.082-2.922-0.671-4.04-1.671l-47.94-47.6c-1-1.105-1.589-2.521-1.67-4.01V481"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_67_","fill":"none","stroke-dashoffset":"100%","stroke":"#9DCA40","d":"M504.43,324v-35.16c0-1.3,0.75-3.1,1.67-4.02l47.94-47.6c1.119-0.996,2.544-1.582,4.04-1.66h97.84c1.5,0.077,2.928,0.662,4.05,1.66l47.931,47.6c1.006,1.106,1.599,2.526,1.68,4.02V324"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_26_","fill":"none","stroke-dashoffset":"100%","stroke":"#1EB2D8","d":"M509.75,502.17v33.3c0,1.08,0.63,2.58,1.4,3.351l87.369,86.76c0.771,0.76,0.511,1.39-0.569,1.39H295"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_27_","fill":"none","stroke-dashoffset":"100%","stroke":"#BC6D21","d":"M681.96,248.32v-18.86c0-1.08,0.63-2.59,1.4-3.35l30.899-30.68c0.933-0.835,2.121-1.329,3.37-1.4H1100"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_28_","fill":"none","stroke-dashoffset":"100%","stroke":"#ED8E3F","d":"M495.167,480.999l-0.007,8.831c0,1.08,0.63,2.6,1.38,3.35l53.63,53.271c0.934,0.831,2.122,1.321,3.37,1.39h46.56c1.08,0,2.601,0.63,3.37,1.391l173.96,172.75c0.937,0.833,2.129,1.323,3.38,1.39h264.721c1.09,0,1.97,0.88,1.97,1.96v93.24c0,1.08,0.9,1.96,1.98,1.96h224.539"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_23_","fill":"none","stroke-dashoffset":"100%","stroke":"#ED8E3F","d":"M841-74.77l12.58,12.47c0.834,0.926,1.334,2.106,1.42,3.35l0.36,21.45c-0.047,1.242-0.528,2.427-1.36,3.35L664.64,153.9c-0.77,0.76-1.399,2.27-1.399,3.35v18.41c0,1.08-0.891,1.96-1.971,1.96H573.41c-1.09,0-1.98,0.88-1.98,1.96v34.67c0,1.08-0.88,1.96-1.97,1.96h-23.3c-1.08,0-2.601,0.63-3.37,1.4l-46.16,45.83c-0.77,0.77-1.399,2.28-1.399,3.35V324"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_17_","fill":"none","stroke-dashoffset":"100%","stroke":"#DA5A98","d":"M452.003,385.262L431.06,364.46c-0.836-0.924-1.33-2.106-1.4-3.35v-76c0-1.08-0.9-1.96-1.98-1.96h-37.9c-2.209,0-4-1.791-4-4v-29.3c0-1.08-0.63-2.59-1.4-3.35l-35.35-35"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_65_","fill":"none","stroke-dashoffset":"100%","stroke":"#DA5A98","d":"M742.93,587.97l-63.3-62.859c-0.932-0.836-2.12-1.329-3.37-1.4H551.59c-1.08,0-2.6-0.6-3.37-1.37l-28.229-27.83c-0.839-0.914-1.334-2.091-1.4-3.33V481"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_1_","fill":"none","stroke-dashoffset":"100%","stroke":"#1AA5D0","d":"M614.199,324l10.161-10.089c0.934-0.832,2.121-1.322,3.37-1.391H773.51c1.08,0,2.601,0.631,3.37,1.4l10.149,10.079"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_63_","fill":"none","stroke-dashoffset":"100%","stroke":"#1AA5D0","d":"M264.9,349.7l45.6,45.3c0.935,0.828,2.123,1.314,3.37,1.38H452"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_31_","fill":"none","stroke-dashoffset":"100%","stroke":"#55B549","d":"M869.48,615.2h46.899c1.09,0,1.98,0.88,1.98,1.95V643.8c0,1.07,0.89,1.95,1.97,1.95h89.32"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_62_","fill":"none","stroke-dashoffset":"100%","stroke":"#D3C452","d":"M452,424.01h-8.53c-1.08,0-2.6,0.62-3.37,1.391l-37.26,37c-0.77,0.76-2.3,1.399-3.38,1.399h-21.7"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_16_","fill":"none","stroke-dashoffset":"100%","stroke":"#D3C452","d":"M1002.305,78.955L867.01,214.19c-0.77,0.76-2.29,1.39-3.37,1.39l-146.76-0.2c-1.09,0-2.6,0.63-3.38,1.37L604.415,324"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_33_","fill":"none","stroke-dashoffset":"100%","stroke":"#9DCA40","d":"M1274.02,816.87h-216.77c-1.09,0-1.97-0.89-1.97-1.96v-99.83c0-1.08-0.9-1.96-1.98-1.96H787.06c-1.079,0-2.6-0.62-3.369-1.39l-20.181-20.04c-0.77-0.761-0.77-2.021,0-2.761l78.7-78.199c0.836-0.924,1.33-2.106,1.4-3.351v-1.57c0-1.069-0.88-1.96-1.971-1.96l-139.22,0.021c-1.09,0-2.6-0.62-3.38-1.39L645.34,549c-0.755-0.759-1.739-1.248-2.8-1.39c-0.76,0-1.41-0.88-1.41-1.96v-6.62"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_60_","fill":"none","stroke-dashoffset":"100%","stroke":"#B00D7C","d":"M600.075,324.001L573.55,297.66c-0.935-0.838-2.127-1.331-3.38-1.4H408.61c-1.08,0-1.97,0.891-1.97,1.96v178.66c0,1.07,0.63,2.58,1.4,3.351l11.42,11.34c0.936,0.833,2.128,1.323,3.38,1.39h206.13c1.768-0.938,1.978-1.438,1.98-1.96v-10"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_59_","fill":"none","stroke-dashoffset":"100%","stroke":"#B00D7C","d":"M1103.463-30.563L910.08,162.82L766.92,305.47c-0.77,0.771-1.4,2.271-1.4,3.351V324"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_19_","fill":"none","stroke-dashoffset":"100%","stroke":"#DA5A98","d":"M668.351,480.994l9.739,9.676c0.937,0.834,2.128,1.324,3.38,1.39H865.1"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_14_","fill":"none","stroke-dashoffset":"100%","stroke":"#DA5A98","d":"M452,369.662l-16.91,16.928c-0.831,0.926-1.318,2.108-1.38,3.351l0.02,30.34c0,1.08,0.63,2.59,1.4,3.35l4.91,4.88c0.932,0.836,2.121,1.329,3.37,1.4H452"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_12_","fill":"none","stroke-dashoffset":"100%","stroke":"#DA5A98","d":"M507.58-103.35v211.36c0,1.08-0.63,2.59-1.4,3.35l-46.729,46.4c-0.77,0.771-1.4,2.28-1.4,3.36v35.79l2.49-0.14c0.75,0,1.97,0.63,2.74,1.4l18.32,18.19c0.836,0.924,1.33,2.106,1.4,3.35V324"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_36_","fill":"none","stroke-dashoffset":"100%","stroke":"#1EB2D8","d":"M876.52,720v84.33c0,1.08,0.891,1.96,1.971,1.96h57.479c1.091,0,1.98,0.88,1.98,1.96v10.36c0,1.08,0.88,1.96,1.97,1.96h107.561"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_37_","fill":"none","stroke-dashoffset":"100%","stroke":"#F5C739","d":"M1147.05,337.32L1033.65,449.94c-0.78,0.77-2.301,1.399-3.381,1.399H994.15c-1.08,0-2.601,0.62-3.37,1.38L785.33,656.75c-0.771,0.76-2.29,1.39-3.37,1.39l-62.74,0.03H689.69c-1.091,0-2.601,0.63-3.37,1.4L669.96,675.8c-0.77,0.771-2.29,1.4-3.37,1.4H192.415"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_38_","fill":"none","stroke-dashoffset":"100%","stroke":"#31B495","d":"M882.18,565.44L857.74,541.17c-0.933-0.835-2.121-1.329-3.37-1.4H732.85c-1.08,0-2.6,0.631-3.369,1.4l-34.32,34.08c-0.771,0.77-2.3,1.4-3.38,1.4h-54.36"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_39_","fill":"none","stroke-dashoffset":"100%","stroke":"#AD7D20","d":"M524.59,253.74l21.36-21.22c0.836-0.924,1.33-2.106,1.399-3.35v-332.75"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_51_","fill":"none","stroke-dashoffset":"100%","stroke":"#1F8C43","d":"M835,434.58h40.85c1.08,0,2.601,0.63,3.37,1.37l62.101,61.3c0.936,0.826,2.123,1.309,3.369,1.37h69.851c1.09,0,2.6,0.63,3.37,1.399l68.22,67.73c0.933,0.835,2.12,1.329,3.37,1.4h34.4c1.09,0,2.6,0.619,3.38,1.38l61.64,61.22c0.836,0.924,1.33,2.106,1.4,3.35v98.021c0,1.08,0.89,1.96,1.97,1.96h30.76c1.08,0,2.601,0.63,3.37,1.4l48.29,47.949"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_56_","fill":"none","stroke-dashoffset":"100%","stroke":"#1F8C43","d":"M403.6-3.5v190.63c0,1.08,0.9,1.96,1.98,1.96h94.49c1.08,0,2.6,0.63,3.37,1.4l50.279,49.93c0.836,0.924,1.33,2.106,1.4,3.35v56.41c0,1.08-0.63,2.59-1.4,3.351l-10.63,10.56c-0.77,0.76-1.399,2.271-1.399,3.351V324"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_41_","fill":"none","stroke-dashoffset":"100%","stroke":"#74BB63","d":"M973.45,397.03v34.09c0,1.07,0.63,2.58,1.399,3.35l56.48,55.88c0.932,0.836,2.12,1.329,3.37,1.4H1192.6"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_42_","fill":"none","stroke-dashoffset":"100%","stroke":"#E5683E","d":"M177.88,391.59l15.05-14.95c0.935-0.837,2.127-1.331,3.38-1.399h46.04c1.08,0,2.6,0.63,3.37,1.399l14.5,14.4c0.771,0.76,1.4,0.5,1.4-0.57v-34.93c0-1.08,0.63-2.58,1.4-3.35l2.48-2.471"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_43_","fill":"none","stroke-dashoffset":"100%","stroke":"#DA5A98","d":"M331.23,213.25v54.43c0,1.08-0.63,2.59-1.4,3.35l-86.38,85.78c-0.77,0.771-2.29,1.4-3.37,1.4h-98.61c-1.09,0-2.6-0.63-3.36-1.4l-22.6-22.8c-0.929-0.833-2.114-1.323-3.36-1.39H5.77c-1.08,0-1.97-0.88-1.97-1.96l-0.04-95.24c0-1.08-0.89-1.96-1.97-1.96h-39.02c-1.09,0-1.97,0.88-1.97,1.96v48.1"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_44_","fill":"none","stroke-dashoffset":"100%","stroke":"#3EB373","d":"M198.77,101.08l-19.2,19.06c-0.76,0.76-2.28,1.39-3.36,1.39H-1.21c-1.09,0-1.97,0.88-1.97,1.96v100.84c0,1.657-1.343,3-3,3H-42.6c-1.08,0-1.97,0.88-1.97,1.96v54.65"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_45_","fill":"none","stroke-dashoffset":"100%","stroke":"#2765B0","d":"M1124.83,773.75H882.71c-1.08,0-1.97-0.88-1.97-1.96V647.9c0-1.08,0.89-1.96,1.97-1.96h30.12c0.522,0.002,1.024-0.203,1.396-0.57c0.372-0.367,0.582-0.867,0.585-1.39V617.22c0-1.069,0.879-1.96,1.97-1.96h20.87"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_55_","fill":"none","stroke-dashoffset":"100%","stroke":"#EB9D12","d":"M510.42,324v-38.4c0-1.08-0.88-1.96-1.97-1.96h-77.38"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape_47_","fill":"none","stroke-dashoffset":"100%","stroke":"#9DCA40","d":"M1192.939,377.19V488.38c0,1.07-0.629,2.58-1.399,3.351l-49.06,48.71c-0.761,0.77-2.28,1.399-3.37,1.399h-21.8c-1.08,0-2.601,0.62-3.371,1.391l-113,112.22c-0.779,0.77-2.3,1.399-3.379,1.399H826.96c-1.08,0-1.97,0.87-1.97,1.95v60.41"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dd8D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e7+m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fNC6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6625bac5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("Ksms");
function injectStyle (ssrContext) {
  __webpack_require__("e7+m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6625bac5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6625bac5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lwq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  connected: false
});

/***/ }),

/***/ "mUbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  updateKeyValue: function updateKeyValue(_ref, _ref2) {
    var commit = _ref.commit;
    var key = _ref2.key,
        value = _ref2.value;

    commit('UPDATE_KEYVALUE', { key: key, value: value });
  }
});

/***/ }),

/***/ "teIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("HCTz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f949c7de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("ym/I");
function injectStyle (ssrContext) {
  __webpack_require__("/1vZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f949c7de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f949c7de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  UPDATE_KEYVALUE: function UPDATE_KEYVALUE(state, _ref) {
    var key = _ref.key,
        value = _ref.value;

    // NOTE: Only used when super lazy/super sure its not important
    state[key] = value;
  }
});

/***/ }),

/***/ "vdG/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs__ = __webpack_require__("A5qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_animejs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',

  mounted: function mounted() {
    var pathEls = document.querySelectorAll('path');
    for (var i = 0; i < pathEls.length; i++) {
      var pathEl = pathEls[i];
      var offset = __WEBPACK_IMPORTED_MODULE_0_animejs___default.a.setDashoffset(pathEl);
      pathEl.setAttribute('stroke-dashoffset', offset);
      __WEBPACK_IMPORTED_MODULE_0_animejs___default()({
        targets: pathEl,
        strokeDashoffset: [offset, '100%'],
        duration: __WEBPACK_IMPORTED_MODULE_0_animejs___default.a.random(3000, 230000),
        delay: __WEBPACK_IMPORTED_MODULE_0_animejs___default.a.random(0, 1000),
        loop: true,
        direction: 'alternate',
        easing: 'easeInOutSine',
        autoplay: true
      });
    }
  }
});

/***/ }),

/***/ "x75/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('Header'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_vue__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer_vue__ = __webpack_require__("TVmP");
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',

  components: {
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header_vue__["a" /* default */],
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_Footer_vue__["a" /* default */]
  },

  watch: {
    $route: function $route(to) {
      if (!window.gtag) return;
      // update google analytics
      window.gtag('config', 'UA-126384659-1', {
        page_title: to.name,
        page_path: to.fullPath
      });
    }
  }
});

/***/ }),

/***/ "ym/I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-bar"},[_c('div',{staticClass:"header-wrap"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":{name: 'Home'},"tag":"a"}},[_c('img',{attrs:{"src":"/static/web3data_logo_bug_color_v1.svg","alt":""}})])],1),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-menu"},[_c('a',{attrs:{"href":"mailto:connect@web3data.org"}},[_c('span',[_vm._v("Contact Us")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f3a93b7638055d90d1ec.js